import globalStyles from '../../../../global.less'
import styles from '../index.less'
const getSty = (str: string) => styles[str]
const fonSizeBold = (str: string, cla?: string) => (
  <span className={`${getSty('KeyPoint')} ${cla ? styles[cla] : ''}`}>
    {str}
  </span>
)
const fontBoldUnderline = (str: string) => (
  <span className={`${getSty('KeyPoint')} ${getSty('underline')}`}>{str}</span>
)
export default function ProtocolDPAUS() {
  return (
    <div className={`${globalStyles['container']} ${getSty('protocol')}`}>
      <h2 className={getSty('title-h2')}>
        ข้อตกลงความเป็นส่วนตัวข้อมูลของช่องทางเสียวหมี่
      </h2>
      <p className={getSty('explain-title')}>บทบัญญัติทั่วไป</p>
      <div className={getSty('item-box')}>
        <ol>
          <li>
            <h5 className={getSty('explain')}>ความครบถ้วนสมบูรณ์ของข้อตกลงนี้</h5>
            <p className={getSty('explain')}>
              ข้อตกลงนี้ประกอบด้วย {fonSizeBold('ข้อกำหนดทั่วไปเหล่านี้')},
              ประกาศความเป็นส่วนตัวของช่องทางเสียวหมี่ด้านล่าง{' '}
              {fonSizeBold('(“ประกาศความเป็นส่วนตัว”)')} 
              และข้อตกลงการประมวลผลข้อมูลของช่องทางเสียวหมี่ด้านล่าง{' '}
              {fonSizeBold(
                '(“DPA” และไม่ควรสับสนกับ “ข้อตกลงนี้” ตามที่ได้ให้คำนิยามไว้ในย่อหน้านี้),'
              )}{' '}
              ซึ่งทั้งสามส่วนนี้ถือเป็นส่วนประกอบที่สำคัญของข้อตกลงนี้.
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>
              ความยินยอมของท่านและการอนุญาตของผู้ค้าปลีก
            </h5>
            <p className={getSty('explain')}>
              {fonSizeBold(
                'โดยการยอมรับข้อตกลงนี้เป็นครั้งแรกในช่องทางเสียวหมี่ ท่านยินยอมว่า:'
              )}
            </p>
            <p className={getSty('explain')}>
              (1) เสียวหมี่อาจประมวลผลข้อมูลส่วนบุคคลของท่านตามที่ระบุไว้ในประกาศความเป็นส่วนตัว;
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '(2) หากนี่เป็นการยอมรับ DPA เป็นครั้งแรกโดยพนักงานของผู้ค้าปลีก'
              )}
              {''} ซึ่งท่านใช้ช่องทางเสียวหมี่ {fonSizeBold('(ผู้ค้าปลีก)')}{' '}
              และผู้ที่เข้าร่วมในโครงการจูงใจของเสียวหมี่สำหรับการขายให้กับผู้บริโภคปลายทาง, {fontBoldUnderline('ท่าน:')}
            </p>
            <p className={getSty('explain')}>
              {fontBoldUnderline(
                '(i) แถลงและรับรองว่าท่านได้รับอนุญาตอย่างถูกต้องตามกฎหมายหรือจากผู้ค้าปลีกให้ผูกพันผู้ค้าปลีกตาม DPA และสั่งการให้เสียวหมี่ในนามของผู้ค้าปลีกประมวลผลข้อมูลส่วนบุคคลตาม DPA,'
              )}{' '}
              ซึ่งอนุญาตให้เสียวหมี่ประมวลผลข้อมูลส่วนบุคคลในนามของผู้ค้าปลีกตามที่ระบุไว้ในนั้น;
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold('(ii) โดยที่ผูกพันผู้ค้าปลีกให้เป็นไปตาม DPA; และ') }
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold('(iii) รับทราบคำสั่งใด ๆ ที่ส่งถึงเสียวหมี่ จากท่านและพนักงานอื่นใดของผู้ค้าปลีกที่ได้รับอนุญาตตามที่ระบุใน (2)(i) ให้ดำเนินการเกี่ยวกับข้อมูลส่วนบุคคล คำสั่งดังกล่าวถือเป็นคำสั่งจากผู้ค้าปลีก,')}
              {fontBoldUnderline(' ไม่ว่าจะเป็นคำสั่งโดยวาจาหรือโดยพฤติกรรม (เช่น การส่งข้อมูลส่วนบุคคลไปยังเสียวหมี่ในช่องทางเสียวหมี่) และไม่ว่าจะเป็นคำสั่งโดยชัดแจ้งหรือโดยนัย แต่ความเงียบไม่ถือเป็นคำสั่ง;')}
            </p>
            <p className={getSty('explain')}>
              (3) การยอมรับข้อตกลงนี้ของท่านมีผลทางกฎหมายเทียบเท่ากับลายเซ็นที่ท่านได้ลงนามอย่างถูกต้องบนกระดาษ;
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '(4) ไม่ถือเป็นข้อแก้ต่างสำหรับท่านหรือผู้ค้าปลีกในการปฏิเสธการใช้ข้อตกลงนี้โดยอ้างเหตุขาดการ:'
              )}
            </p>
            <p className={getSty('explain')}>
              {fontBoldUnderline('(i) อ่าน ทำความเข้าใจ และยอมรับข้อตกลงนี้โดยสมบูรณ์; หรือ') }
            </p>
            <p className={getSty('explain')}>
              {fontBoldUnderline('(ii) ได้รับอนุญาตอย่างถูกต้องจากผู้ค้าปลีกเพื่อผูกพันผู้ค้าปลีกให้เป็นไปตาม DPA; และ') }
            </p>
            <p className={getSty('explain')}>
              {fontBoldUnderline('(5) ท่านต้องชดใช้ค่าเสียหายและคุ้มครองเสียวหมี่ให้พ้นจากความเสียหาย โดยเป็นค่าใช้จ่ายของท่านเอง ต่อข้อกล่าวหา ข้อเรียกร้อง การดำเนินคดี คำฟ้อง การเรียกร้องค่าเสียหาย ความรับผิด ภาระผูกพัน ความสูญเสีย การระงับข้อพิพาท คำพิพากษา ค่าใช้จ่าย และค่าใช้จ่ายอื่นใด อันเกิดจาก สัมพันธ์กับ หรือเป็นผลมาจาก การงดเว้นหรือการให้ข้อมูลที่บิดเบือน ไม่ว่าท่านจะทราบหรือไม่ก็ตาม เกี่ยวกับการให้อำนาจของผู้ค้าปลีกตามที่กำหนดไว้ในข้อ (2)(i) ข้างต้น (หรือเกี่ยวกับข้อบกพร่องหรือการไม่มีอยู่จริงของการอนุญาตนั้น)')}
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>
              การแยกส่วนของข้อตกลงฉบับนี้
            </h5>
            <p className={getSty('explain')}>
            หากข้อกำหนดใดของข้อตกลงนี้ถูกพิจารณาว่าเป็นโมฆะ ผิดกฎหมาย หรือไม่สามารถบังคับใช้ได้ไม่ว่าประการใด ๆ ต่อเสียวหมี่ ท่าน หรือผู้ค้าปลีก 
            (แต่ละฝ่ายเรียกว่า {fonSizeBold('“คู่สัญญาฝ่ายหนึ่ง”')} และการรวมกันของคู่สัญญาดังกล่าวเรียกว่า {fonSizeBold('“คู่สัญญา”,')} 
            เว้นแต่จะระบุไว้เป็นอย่างอื่นใน DPA ด้านล่าง) ความถูกต้อง ความชอบด้วยกฎหมาย และความสามารถในการบังคับใช้ของข้อกำหนดที่เหลืออยู่ (รวมถึงข้อกำหนดดังกล่าวต่อคู่สัญญาอื่น ๆ) จะไม่ถูกกระทบหรือทำให้เสื่อมเสียไปไม่ว่าด้วยประการใด.
            </p>
          </li>
        </ol>
      </div>
      <p className={getSty('explain-title')}>ประกาศความเป็นส่วนตัวของช่องทางเสียวหมี่</p>
      <div className={getSty('item-box')}>
        <p className={getSty('explain')}>
        ช่องทางเสียวหมี่ให้บริการแก่ท่านในด้านการแสดงผลการขาย การคำนวณสิ่งจูงใจ และ บริการ อื่น ๆ (รวมถึงรูปแบบการให้บริการอื่นใดที่อาจเกิดขึ้นในอนาคต)เพื่อให้สามารถปฏิบัติหน้าที่ดังกล่าวได้ เราอาจเก็บรวบรวม ประมวลผล และแบ่งปันข้อมูลส่วนบุคคลของท่านดังต่อไปนี้:
        </p>
        <h5 className={getSty('explain')}>การยืนยันตัวตนของพนักงาน</h5>
        <p className={getSty('explain')}>
        ช่องทางเสียวหมี่เปิดให้เฉพาะบุคลากรบางกลุ่มเท่านั้น (เช่น พนักงานที่ได้รับอนุญาตให้ปฏิบัติงานในพื้นที่ร้านค้าของผู้ค้าปลีก) และต้องมีการยืนยันตัวตนเพื่อแสดงข้อมูลในช่องทางเสียวหมี่และสนับสนุนการใช้งานของท่านตามสิทธิ์ของผู้ใช้ ซึ่งเรา{' '}
          {fonSizeBold('("เสียวหมี่")')} จำเป็นต้องเก็บรวบรว{' '}
          {fonSizeBold(
            'มข้อมูลบัญชีเสียวหมี่ของท่าน (รวมถึงรหัสบัญชีเสียวหมี่) ชื่อ หมายเลขโทรศัพท์มือถือ และที่อยู่อีเมล'
          )}{' '}
          ที่ท่านได้ให้ไว้โดยสมัครใจ.
        </p>
        <p className={getSty('explain')}>
          {fonSizeBold(
            'ฐานทางกฎหมายสำหรับกิจกรรมการประมวลผลข้อมูลส่วนบุคคลของท่านนี้ คือ การได้รับความยินยอมจากท่าน.'
          )}
        </p>
      </div>
      <div className={getSty('item-box')}>
        <p className={getSty('explain')}>
          นอกจากนี้ เราจะยังคงใช้ข้อมูลส่วนบุคคลดังกล่าวและข้อมูลส่วนบุคคลอื่น ๆ ที่ท่านให้ไว้แก่เราเพื่อวัตถุประสงค์ต่าง ๆ เช่น การบริหารจัดการร้านค้าและการบริหารทรัพยากรบุคคล.
        </p>
        <p className={getSty('explain')}>
          โปรดมั่นใจว่าเมื่อเราประมวลผลข้อมูลส่วนบุคคลของท่าน เราจะปฏิบัติตามกฎหมายที่เกี่ยวข้องอย่างเคร่งครัด และจะประมวลผลข้อมูลส่วนบุคคลในปริมาณขั้นต่ำที่จำเป็นเท่านั้น.
        </p>
        <p className={getSty('explain')}>
          โปรดดูนโยบายความเป็นส่วนตัวของเราที่{' '}
          <a
            href='https://privacy.mi.com/all/languages'
            target='_blank'
            rel='noopener noreferrer'
          >
            https://privacy.mi.com/all/languages
          </a>{' '}
          เพื่อข้อมูลเพิ่มเติมเกี่ยวกับวิธีการที่เราประมวลผลข้อมูลส่วนบุคคลของท่าน.
        </p>
        <h5 className={getSty('explain')}>
          ข้อตกลงการประมวลผลข้อมูลของช่องทางเสียวหมี่
        </h5>
      </div>
      <div className={getSty('item-box')}>
        <ol>
          <li>
            <h5 className={getSty('explain')}>วัตถุประสงค์</h5>
            <p className={getSty('explain')}>
              ข้อตกลงการประมวลผลข้อมูลฉบับนี้จัดทำขึ้นระหว่างเสียวหมี่และผู้ค้าปลีกเท่านั้น
              (แต่ละฝ่ายเรียกว่า {fonSizeBold('คู่สัญญา')}และรวมกันเรียกว่า{' '}
              {fonSizeBold('“คู่สัญญาทั้งสองฝ่าย”)')} โดยไม่รวมถึงผู้ใช้ที่กล่าวถึงก่อนหน้านี้ในฐานะ “ท่าน”.{' '}
              {fonSizeBold(
                'เสียวหมี่มิได้ประมวลผลข้อมูลส่วนบุคคลของผู้บริโภคปลายทางเพื่อวัตถุประสงค์ของตนเองโดยเจตนา และในกรณีที่ผู้ค้าปลีกสั่งให้ประมวลผลข้อมูลส่วนบุคคลดังกล่าว การประมวลผลจะต้องเป็นไปตามข้อตกลงนี้ ในนามของผู้ค้าปลีก และเพื่อวัตถุประสงค์ที่ผู้ค้าปลีกสั่งเท่านั้นคู่สัญญาตระหนักดีว่าในทุกกรณีที่ข้อตกลงการประมวลผลข้อมูลส่วนบุคคลฉบับนี้กำหนดให้มีการประมวลผลข้อมูลส่วนบุคคล การประมวลผลดังกล่าวจะต้องอยู่ภายใต้เงื่อนไขที่ผู้ค้าปลีกสั่งให้เสียวหมี่ประมวลผลข้อมูลส่วนบุคคลของผู้บริโภคปลายทาง.'
              )}
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>บทบาทและการปฏิบัติตามกฎหมาย</h5>
            <p className={getSty('explain')}>
              2.1 คู่สัญญาตระหนักดีว่าผู้ค้าปลีกทำหน้าที่เป็นผู้ควบคุมข้อมูล (data controller) และเสียวหมี่ทำหน้าที่เป็นผู้ประมวลผลข้อมูล (data processor) ซึ่งประมวลผลข้อมูลส่วนบุคคลบางส่วนในนามของผู้ค้าปลีกภายใต้กฎหมายคุ้มครองข้อมูลที่บังคับใช้.
            </p>
            <p className={getSty('explain')}>
              2.2 สำหรับวัตถุประสงค์ของข้อตกลงการประมวลผลข้อมูลนี้ “ผู้ควบคุมข้อมูล” หมายถึงคู่สัญญาที่ตัดสินใจเกี่ยวกับวัตถุประสงค์และวิธีการในการประมวลผลข้อมูลส่วนบุคคล และ “ผู้ประมวลผลข้อมูล” หมายถึงคู่สัญญาที่ประมวลผลข้อมูลส่วนบุคคลในนามของผู้ควบคุมข้อมูล.
            </p>
            <p className={getSty('explain')}>
              2.3 เสียวหมี่จะประมวลผลข้อมูลส่วนบุคคลในนามของผู้ค้าปลีกตามข้อตกลงการประมวลผลข้อมูลนี้และคำสั่งที่ชอบด้วยกฎหมายของผู้ค้าปลีก.
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '2.4 ผู้ค้าปลีกต้องรับประกันว่าคำสั่งของตนเป็นไปตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลที่บังคับใช้ตลอดเวลา.'
              )}{' '}
              เสียวหมี่จะแจ้งให้ผู้ค้าปลีกทราบโดยไม่ล่าช้าเกินสมควรหากเสียวหมี่ทราบหรือเชื่ออย่างมีเหตุผลว่าคำสั่งนั้นละเมิดกฎหมายคุ้มครองข้อมูลส่วนบุคคลที่บังคับใช้, 
              {fonSizeBold('แต่การที่เสียวหมี่ไม่แจ้งให้ผู้ค้าปลีกทราบจะไม่ส่งผลกระทบต่อความรับผิดชอบและหน้าที่รับผิดของผู้ค้าปลีกต่อคำสั่งดังกล่าว.') }
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '2.5 ผู้ค้าปลีกต้องรับประกันว่ากิจกรรมการประมวลผลข้อมูลของเสียวหมี่มีฐานทางกฎหมายที่เหมาะสม.'
              )}
            </p>
            <p className={getSty('explain')}>
              2.6 เสียวหมี่จะดำเนินการตามขั้นตอนที่จำเป็นตามคำแนะนำของผู้ค้าปลีก เพื่อช่วยเหลือผู้ค้าปลีกให้ปฏิบัติตามภาระหน้าที่ภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคล.
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '2.7 ผู้ค้าปลีกต้องรับผิดชอบแต่เพียงผู้เดียวต่อคำเรียกร้องหรือความเสียหายใด ๆ ที่เกิดขึ้นจากการไม่ปฏิบัติตามภาระหน้าที่ของผู้ควบคุมข้อมูลและกฎหมายคุ้มครองข้อมูลที่บังคับใช้.'
              )}
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold('2.8 ผู้ค้าปลีกได้รับแจ้งว่า,')} 
              เนื่องจากข้อมูลส่วนบุคคลของผู้บริโภคปลายทางที่เกี่ยวข้องกับผลิตภัณฑ์ของเสียวหมี่ถือเป็นข้อมูลที่มีคุณค่าสำหรับเสียวหมี่,{' '}
              {fonSizeBold(
                'ผู้ค้าปลีกจะต้องไม่เปิดเผยข้อมูลส่วนบุคคลดังกล่าวแก่บุคคลที่สามใด ๆ โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรจากเสียวหมี่.'
              )}
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>สิทธิของเจ้าของข้อมูล</h5>
            <p className={getSty('explain')}>
              3.1{' '}
              {fonSizeBold(
                'ผู้ค้าปลีกต้องรับผิดชอบแต่เพียงผู้เดียวในการปฏิบัติตามภาระหน้าที่ใด ๆ ที่เกี่ยวข้องกับคำขอใช้สิทธิของเจ้าของข้อมูลภายใต้กฎหมายคุ้มครองข้อมูลที่บังคับใช้.'
              )}{' '}
              เสียวหมี่จะให้ความช่วยเหลือแก่ผู้ค้าปลีกอย่างสมเหตุสมผลด้วยมาตรการทางเทคนิคและองค์กรที่เหมาะสม เพื่อให้ผู้ค้าปลีกสามารถปฏิบัติตามภาระหน้าที่ในการตอบสนองต่อคำขอดังกล่าว.
            </p>
            <p className={getSty('explain')}>
              3.2 เสียวหมี่จะแจ้งให้ผู้ค้าปลีกทราบโดยไม่ล่าช้าหลังจากได้รับคำขอเพื่อใช้สิทธิของเจ้าของข้อมูล พร้อมด้วยข้อมูลเพิ่มเติมที่เกี่ยวข้องซึ่งจำเป็นในการดำเนินการตามคำขอดังกล่าว.
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>การละเมิดข้อมูล</h5>
            <p className={getSty('explain')}>คู่สัญญาแต่ละฝ่าย:</p>
            <p className={getSty('explain')}>
              4.1 จะต้องแจ้งให้คู่สัญญาอีกฝ่ายทราบโดยทันทีเพื่อดำเนินมาตรการป้องกันการละเมิดความปลอดภัยใด ๆ ที่เกี่ยวข้องกับข้อมูลส่วนบุคคลภายใต้ความรับผิดชอบของตน ซึ่งก่อให้เกิดหรืออาจก่อให้เกิดการเข้าถึง การส่งผ่าน การดักฟัง การใช้ การเปิดเผย การเปลี่ยนแปลง การรวม การทำลาย การสูญหาย หรือการประมวลผลข้อมูลส่วนบุคคลโดยไม่ได้รับอนุญาตโดยบังเอิญหรือโดยผิดกฎหมาย{' '}
              {fonSizeBold('(แต่ละกรณีดังกล่าวเรียกว่า “การละเมิดข้อมูล”),')} และ
            </p>
            <p className={getSty('explain')}>
              4.2 จะต้องให้ความร่วมมืออย่างสมเหตุสมผลกับคู่สัญญาอีกฝ่าย และดำเนินการตามขั้นตอนที่สมเหตุสมผลเพื่อช่วยในการสืบสวน บรรเทา และแก้ไขการละเมิดข้อมูลดังกล่าว.
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>ความมั่นคงปลอดภัย</h5>
            <p className={getSty('explain')}>คู่สัญญาแต่ละฝ่ายจะต้อง:</p>
            <p className={getSty('explain')}>
              5.1 มีมาตรการทางเทคนิคและองค์กรที่เหมาะสมตามกฎหมายคุ้มครองข้อมูลที่บังคับใช้ทั้งหมด เพื่อปกป้องข้อมูลส่วนบุคคลจากการทำลาย สูญหาย หรือเสียหายโดยไม่ตั้งใจหรือโดยผิดกฎหมาย การเปลี่ยนแปลง การเปิดเผยหรือเข้าถึงโดยไม่ได้รับอนุญาต และการประมวลผลในรูปแบบที่ผิดกฎหมายอื่น ๆ ทั้งหมด;
            </p>
            <p className={getSty('explain')}>
              5.2 ดำเนินการทุกขั้นตอนที่จำเป็นเพื่อให้แน่ใจว่าเฉพาะพนักงานที่ได้รับอนุญาตเพื่อวัตถุประสงค์ในการอำนวยความสะดวกตามภาระหน้าที่ภายใต้ข้อตกลงการประมวลผลข้อมูลนี้เท่านั้นที่สามารถเข้าถึงข้อมูลส่วนบุคคลได้;
            </p>
            <p className={getSty('explain')}>
              5.3 รับรองว่าพนักงานแต่ละคนที่เข้าถึงข้อมูลส่วนบุคคลเข้าใจภาระหน้าที่ของตนภายใต้ข้อตกลงการประมวลผลข้อมูลนี้และกฎหมายคุ้มครองข้อมูลที่บังคับใช้ทั้งหมด; และ
            </p>
            <p className={getSty('explain')}>
              5.4 รับรองความน่าเชื่อถือของพนักงานที่เข้าถึงข้อมูลส่วนบุคคล และรับรองว่าบุคลากรดังกล่าวได้รับการฝึกอบรมที่เหมาะสมเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคลและได้ทำข้อตกลงการรักษาความลับเกี่ยวกับการประมวลผลข้อมูลส่วนบุคคลแล้ว.
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>การชดใช้ค่าเสียหาย</h5>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '6.1 คู่สัญญาแต่ละฝ่ายจะต้องชดใช้ค่าเสียหายและปกป้องคู่สัญญาอีกฝ่ายหนึ่งจากและต่อข้อกล่าวห'
              )}{' '}
              า คำร้อง เรียกร้อง คดี ฟ้องร้อง ความเสียหาย ความรับผิดชอบ ภาระผูกพัน การสูญเสีย การตกลง การตัดสิน ค่าใช้จ่ายและค่าใช้จ่ายทั้งหมด (รวมถึงแต่ไม่จำกัดเพียงค่าทนายความและค่าใช้จ่าย) {' '}
              {fonSizeBold(
                'ที่เกิดขึ้นจาก เกี่ยวข้อง หรือเป็นผลมาจากการกระทำหรือการละเว้นใด ๆ ของฝ่ายที่ผิดสัญญา.'
              )}
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '6.2 ในกรณีใด ๆ เสียวหมี่จะไม่รับผิดชอบต่อความเสียหายที่เกินกว่าค่าธรรมเนียมตามสัญญาที่ผู้ค้าปลีกได้ชำระภายใต้ข้อตกลงนี้.'
              )}
            </p>
          </li>
          <li>
            <h5 className={getSty('explain')}>การยกเลิก</h5>
            <p className={getSty('explain')}>
              โดยไม่กระทบต่อสิทธิหรือวิธีการเยียวยาอื่นใดที่อาจมี (ไม่ว่าจะภายใต้ DPA นี้หรือกฎหมาย),{' '}
              {fonSizeBold('คู่สัญญาฝ่ายใดฝ่ายหนึ่งอาจยกเลิก DPA นี้ได้ทันที')}{' '}
              โดยแจ้งเป็นลายลักษณ์อักษรแก่คู่สัญญาอีกฝ่ายหนึ่ง {fonSizeBold('หาก:')}
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '7.1 คู่สัญญาอีกฝ่ายหนึ่งละเมิดภาระหน้าที่สำคัญใด ๆ ตาม DPA ฉบับนี้ และในกรณีที่เป็นการละเมิดที่สามารถแก้ไขได้ ล้มเหลวในการแก้ไขการละเมิดดังกล่าวหลังจากได้รับหนังสือแจ้งเป็นลายลักษณ์อักษรเพื่อให้แก้ไขภายใน 30 (สามสิบ) วันปฏิทิน; หรือ'
              )}
            </p>
            <p className={getSty('explain')}>
              {fonSizeBold(
                '7.2 ข้อตกลงข้อกำหนดและเงื่อนไขของแพลตฟอร์มช่องทางเสียวหมี่ถูกยุติอย่างถูกต้องระหว่างคู่สัญญา.'
              )}
            </p>
          </li>
        </ol>
      </div>
    </div>
  )
}
